import "./buttons.scss";

import { className } from "utils/strings";

import ICON from "components/icons/tick.svg";

export const CheckButton = (props: {
  onClick: () => void;
  checked: boolean;
  hint?: string;
}): JSX.Element => {
  const onClick = () => {
    props.onClick();
  };

  return (
    <button
      className={className({
        check: true,
        "rg-button": true,
        "checked": props.checked,
        "unchecked": !props.checked,
      })}
      onClick={onClick}
      title={props.hint}
    >
      {props.checked && <img src={ICON} alt="" />}
    </button>
  );
};
